import { TextField, debounce } from "@mui/material";
import React, { ChangeEvent, useEffect } from "react";
import { memo, useState, useCallback } from "react";

interface ISearchFieldProps {
    search: string;
    onSearch: React.Dispatch<React.SetStateAction<string>>;
}

function SearchField({ onSearch, search }: ISearchFieldProps) {
    const [searchText, setSearchText] = useState(search);

    const debounceHandleChange = useCallback(debounce(onSearch, 300), []);

    useEffect(() => {
        debounceHandleChange(searchText);
    }, [searchText]);

    const handleSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
    };

    return (
        <TextField
            value={searchText}
            fullWidth
            onChange={handleSearchTextChange}
            placeholder="Поиск устройств"
        />
    );
}

export default memo(SearchField);
